import { createSelector } from 'reselect';

import { selectStore } from './store';

export const selectUpgradeAccountIsOpen = createSelector(
  selectStore,
  (state) => state.isUpgradeAccountOpen
);

export const selectShowRequestQuoteForm = createSelector(
  selectStore,
  (state) => state.showRequestQuoteForm
);
